const LeftBarData = [
  {
    label: 'Introduction',
    children: [
      'Project Inception'
    ],
  },
  {
    label: 'Discover',
    children: [
      {
        "label": "Observational Studies",
        "children": [
          "User Interview questionnaire for redesigning an existing website/APP ",
          "User Interview questionnaire for creating new Ecommerce Website",
          "Add User Stories",
          "User Profile",
          "User Persona",
          "User Journey Map",
          "Task Analysis",          
        ]
      },
      {
        "label": "Scenario Testing",
        "children": [
          "Usability Report",
        ]
      },      
      'User Diaries for In-Depth Insights',
      'Immersion as the User',
      'Effective Brainstorming',
      'Quantitative surveys',
      'Rapid Idea Visualization through Sketching',
      'Secondary Research for Informed Decision-Making',
    ],
  },
  {
    label: 'Define',
    children: [
      'Exploring with Focus Groups',
      'Selecting and Assessing Ideas with Criteria',
      'Organizing and Prioritizing Ideas: Comparing Notes',
      'Strategizing with Drivers and Hurdles',
      'Visualizing the User Experience: Customer Journey Mapping',
    ],
  },
  {
    label: 'Develop',
    children: [
      {
        "label": "Ideation and Concept Development",        
        "children": [
          "Brainstorming",
          "Paper Sketching",
          "Low Fidelity Wireframe",
          "Stakeholder Presentation & Iterative Design",         
          "User testing plans and protocols",         
          "User Testing Findings, Insights and Implementation",         
          "Mood Boards & Design Inspiration",         
          "Brand Styles, Typography & Guidelines",         
          "User flow diagrams & Information Architecture",         
          "Stakeholder Presentation & Iterative Design",         
        ]
      },{
        "label": "High fidelity wireframe",        
        "children": [
          "High fidelity Prototype",                   
        ]
      },{
        "label": "Stakeholder Presentation & Iterative Design",        
        "children": [
          "Design documentation",                   
          "Usability Test",                   
        ]
      },{
        "label": "Collaboration",        
        "children": [
          "Meeting Minutes",                                                
        ]
      },{
        "label": "Validation",        
        "children": [
          "Validation Findings Report",                                                
        ]
      },
    ],
    /* children: [
      'Character Profiles: Creating user personas with detailed characteristics.',
      'Scenarios: Describing user interactions over time to refine design.',
      'Role-playing: Immersive enactment for design refinement, especially in services.',
      'Service Blueprints: Visualizing the entire service journey, including user touchpoints and backend processes.',
      'Physical: Building models to test and improve design concepts.',
    ], */
  },
  {
    label: 'Deliver',
    children: [
      {
        "label": "Phasing: ",
        /* Gradual delivery to manage risk before a large-scale launch */
        "children": [
          "Implementation Plan",
          "Risk Assessment and Mitigation Plan",
          "Interim Release Notes",
          "Client Handover Documentation",         
        ]
      },
      {
        "label": "Final Testing",
        /* Identifying constraints, ensuring standards compliance, and performing testing before manufacturing */
        "children": [
          "Test Document",
          "Defect Reports",       
        ]
      },   
      {
        "label": "Evaluation",
        /* Assessing project success after launch for informing future projects and proving the impact of good design */
        "children": [
          "Usability Report",
          "User Feedback Summary",       
          "Case Study",       
        ]
      },   
      {
        "label": "Feedback Loops",
        /* Gathering feedback on project issues and suggestions for improvements. */
        "children": [
          "Feedback Document",      
        ]
      }, 
      {
        "label": "Methods Banks",
        /* Documenting and communicating design methods within an organization to encourage best practices and improve efficiency. */
        "children": [
          "Methods Repository or Database",      
          "Documented Design Methods",                   
        ]
      },
      
    ],
  },
  {
    label: 'Documents & Templates',
    children: [
      'Case Study Template',      
      'User Story Template',      
      'User Journey Map Template',      
      'Competitive audit Template',      
      'Persona Template',      
    ],
  },{
    label: 'UX Tools',
    children: [
      'User groups for Survey',
    ],
  },
];

export default LeftBarData;